import { cartWorkflowHandler } from '@phoenix/api/CartWorkflowHandler';
import Bag from '../components/Bag';

import { CART_PREVIEW_ITEM_COUNT, CART_PREVIEW_LOADING, CART_PREVIEW_SET_ITEMS } from './mutations-types';

export default {
  namespaced: true,
  state: {
    cart: null,
    loading: false,
    countFromLocalStorage: 0,
  },
  getters: {
    cartItems: ({ cart }) => (cart && cart.items) || [],
    cartTotal: ({ cart }) => (cart && cart.total) || '',
    hasItems: ({ cart }) => cart?.items?.length > 0,
    initialLoading: ({ cart }) => cart === null,
  },
  actions: {
    async fetchOrders({ commit, dispatch }) {
      commit(CART_PREVIEW_LOADING, true);
      try {
        const cart = await cartWorkflowHandler.fetchCart();
        commit(CART_PREVIEW_SET_ITEMS, { cart });
        dispatch('getItemCountFromResponse', { cart });
      } catch (error) {
        window.Phoenix.sentry.captureException(error);
        dispatch('displayError', error.message || window.Phoenix.i18n.t('Form.validations.default'));
      } finally {
        commit(CART_PREVIEW_LOADING, false);
      }
    },

    async removeProduct({ commit, dispatch }, item) {
      commit(CART_PREVIEW_LOADING, true);

      try {
        const cart = await cartWorkflowHandler.removeItem(item);

        if (item.tracking) {
          window.tracking.pushEvent(window.tracking.getRemoveFromCartTracking(item.tracking));
        }
        commit(CART_PREVIEW_SET_ITEMS, { cart });
        dispatch('getItemCountFromResponse', { cart });
      } catch (error) {
        window.Phoenix.sentry.captureException(error);
        dispatch('displayError', error.message || window.Phoenix.i18n.t('Form.validations.default'));
      } finally {
        commit(CART_PREVIEW_LOADING, false);
      }
    },
    displayError(_, text) {
      window.Phoenix.toaster.notify({ type: 'danger', text });
    },
    getItemCountFromResponse({ commit }, data) {
      const count = Bag.saveShoppingBagTotalFromResponse(data);
      commit(CART_PREVIEW_ITEM_COUNT, count);
    },
    updateShoppingBagCount({ commit }, count) {
      commit(CART_PREVIEW_ITEM_COUNT, count);
    },
  },
  mutations: {
    [CART_PREVIEW_SET_ITEMS](state, { cart }) {
      state.cart = cart;
    },
    [CART_PREVIEW_LOADING](state, isLoading) {
      state.loading = isLoading;
    },
    [CART_PREVIEW_ITEM_COUNT](state, count) {
      state.countFromLocalStorage = count;
    },
  },
};
